import { urlBase } from "src/urls/urlBase";

const apiRoot = 'https://qa.planetun.mobi';
// const apiRoot = 'https://id-prod.planetun.mobi';
// const apiRoot = 'https://id-hom.planetun.mobi';
//const apiRoot = 'https://id-test.planetun.mobi';
//const apiRoot = 'https://localhost:59086';
const apiRootProd = 'https://services.planetun.mobi';
export const environment = {
  production: false,
  qa: true,
  apiRoot,
  secretIV:'1203199320052021',
  apiUrl: apiRoot + "/inspecaodigital/api/v1",
  apiUrlV2: apiRoot + "/inspecaodigital/api/v2",
  apiUrlV3: apiRoot + "/inspecaodigital/api/v3",
  apiUrlV4: apiRoot + "/inspecaodigital/api/v2",
  apiUrlAccessServices: "https://qa.access-services.planetun.mobi/api/Auth",
  apiUrlAccessServicesToken: "J9m!cU6uT$28pVQj@h3ZrF#Lw97X*bE0qYdGv!1SnR$Pf6tL2wBz@K8rXsQ5d",
  keyCloakExchangeCodeUrl: "https://keycloak.servicebus.planetun.mobi/realms/Planetun/protocol/openid-connect/token",
  keyCloakAdUrl: "https://keycloak.servicebus.planetun.mobi/realms/Planetun/protocol/openid-connect/auth",
  keyCloakLogoutUrl: "https://keycloak.servicebus.planetun.mobi/realms/Planetun/protocol/openid-connect/logout",
  // apiUrl: apiRoot + "/api/v1",
  // apiUrlV2: apiRoot + "/api/v2",
  // apiUrlV3: apiRoot + "/api/v3",
  // apiUrlV4: apiRoot + "/api/v2",
  apiAuth: apiRoot + "/inspecaodigitalauth/api/v1",
  //apiAuth: "https://localhost:5001/api/v1",
  authUrl: apiRoot + "/identity/api/v1",
  widgetUrl: apiRoot + "/inspection-dashboard/api/v1",
  //widgetUrl: "https://localhost:5000/api/v1",
   sso: "https://sso.mapfre.com.br/auth/",
  //sso: "https://dev.sso.mapfre.com.br/auth/",
  mobiDashBoardUri:"https://www.planetun.mobi/planetun-v2/sistema/index.cfm?id=457&key",
  mobiLinkViewInspection:"https://www.planetun.mobi/planetun-v2/sistema/index.cfm",
  mobiLinkWorkflow:"https://www.planetun.mobi/planetun-v2/sistema/index.cfm?id=355&key",
  // mobiDashBoardUri: "https://homolog.planetun.mobi/planetun-v2/sistema/index.cfm?id=457&key",
  // mobiLinkViewInspection: "https://homolog.planetun.mobi/planetun-v2/sistema/index.cfm",
  // mobiLinkWorkflow: "https://homolog.planetun.mobi/planetun-v2/sistema/index.cfm?id=355&key"
  // urlQueue: "https://agendamento.planetun.mobi"
  urlQueue: "https://agendamento-hom.planetun.mobi",
  // urlQueue: "https://agendamento-qa.planetun.mobi"
  urlRedirect: window.location.origin + '/auth/login',
  balcaoDash: "https://qa.balcaovirtual-perito.planetun.mobi/dashboard",
  azureAd: {
    clientId: '7747f591-57e1-4b65-9bcc-d0ee844e12b1',
    authority: 'https://login.microsoftonline.com/5cc6c66d-ffb2-469f-9385-cda840e57836',
    redirectUri: window.location.origin + '/auth/login',
    scopes: ['User.Read.All', 'GroupMember.Read.All', 'Group.Read.All']
  }
};
